
import { Injectable, ErrorHandler } from '@angular/core';

@Injectable()
export class DefaultExceptionHandler extends ErrorHandler {
  constructor(rethrow?: boolean) {
    super(!!rethrow);
  }

  call(error, stackTrace = null, reason = null) {
    console.error('================ FATAL ERROR ================');
    console.error(error);
    console.error(reason);
    console.error(stackTrace);

    alert('FATAL ERROR: ' + error);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/core/src/app/services/exception-handler.service.ts